var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9369 27.4998C21.8477 27.1537 21.6673 26.8379 21.4146 26.5851C21.1618 26.3324 20.846 26.152 20.4999 26.0628L14.3649 24.4808C14.2603 24.4511 14.1681 24.388 14.1026 24.3012C14.037 24.2144 14.0015 24.1086 14.0015 23.9998C14.0015 23.891 14.037 23.7851 14.1026 23.6983C14.1681 23.6115 14.2603 23.5485 14.3649 23.5188L20.4999 21.9358C20.8459 21.8466 21.1616 21.6663 21.4143 21.4138C21.6671 21.1613 21.8475 20.8456 21.9369 20.4998L23.5189 14.3648C23.5483 14.2597 23.6113 14.1671 23.6983 14.1012C23.7852 14.0352 23.8913 13.9995 24.0004 13.9995C24.1096 13.9995 24.2157 14.0352 24.3026 14.1012C24.3896 14.1671 24.4525 14.2597 24.4819 14.3648L26.0629 20.4998C26.1522 20.8458 26.3326 21.1617 26.5853 21.4144C26.838 21.6671 27.1539 21.8475 27.4999 21.9368L33.6349 23.5178C33.7404 23.5469 33.8335 23.6098 33.8998 23.6968C33.9661 23.7839 34.002 23.8903 34.002 23.9998C34.002 24.1092 33.9661 24.2156 33.8998 24.3027C33.8335 24.3898 33.7404 24.4527 33.6349 24.4818L27.4999 26.0628C27.1539 26.152 26.838 26.3324 26.5853 26.5851C26.3326 26.8379 26.1522 27.1537 26.0629 27.4998L24.4809 33.6348C24.4515 33.7398 24.3886 33.8324 24.3016 33.8984C24.2147 33.9643 24.1086 34 23.9994 34C23.8903 34 23.7842 33.9643 23.6973 33.8984C23.6103 33.8324 23.5473 33.7398 23.5179 33.6348L21.9369 27.4998Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15V19",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17H30",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29V31",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30H15",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon6);
export default __webpack_public_path__ + "static/media/card-icon6.499c3fef499a2a1874c969ea4f449193.svg";
export { ForwardRef as ReactComponent };